export const costs = [
  'Uncertainty about system design and performance calculations',
  'Troubleshooting by trial-and-error instead of systematic reasoning',
  'Missing career advancement opportunities',
  'Difficulty moving between different project types',
];
